import React from 'react';

import { FormControlLabel, Checkbox } from '@material-ui/core';

export default React.forwardRef(function CheckboxField(
  { name, label, value, onChange },
  ref
) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={!!value}
          onChange={event => {
            onChange(event.target.checked);
          }}
          color="secondary"
          name={name}
        />
      }
      label={label}
    />
  );
});
